import { Component, Show, createSignal } from 'solid-js'
import { CANCELLATION_REASONS } from '../../../common/aifans/lib/cancellation-util'

interface Props {
  show: boolean
  onClose: () => void
  onConfirm: (reason: string) => void
  characterName?: string
  loading?: boolean
}

const CancellationModal: Component<Props> = (props) => {
  const [selectedReason, setSelectedReason] = createSignal('')
  let selectRef: HTMLSelectElement | undefined

  const handleBackgroundClick = (event: MouseEvent) => {
    if (event.target === event.currentTarget) {
      props.onClose()
    }
  }

  return (
    <Show when={props.show}>
      <div
        class="fixed inset-0 z-[200] flex items-center justify-center bg-black/80"
        onClick={handleBackgroundClick}
      >
        <div class="relative mx-2 w-full max-w-[560px] rounded-xl bg-gradient-to-r from-cosplay-purple to-cosplay-blue-200 p-[2px] md:mx-4">
          <div class="relative h-full w-full overflow-hidden rounded-lg bg-[#0B0F11]">
            <button
              onClick={props.onClose}
              class="absolute right-5 top-4 z-10 text-2xl text-white hover:text-white md:right-6 md:top-6 md:text-gray-400"
            >
              ✕
            </button>

            <div class="p-6">
              <h2 class="mb-6 text-2xl font-semibold">Cancel Subscription</h2>

              <div class="flex flex-col gap-4">
                <p class="text-gray-200">
                  Are you sure you want to cancel your subscription to{' '}
                  <span class="font-bold text-white">{props.characterName}</span>?
                </p>

                <div class="form-group">
                  <label class="mb-2 block text-sm font-medium text-gray-200">
                    Please select a reason for cancellation:
                  </label>
                  <select
                    ref={selectRef}
                    required
                    value={selectedReason()}
                    onChange={(e) => setSelectedReason(e.currentTarget.value)}
                    class="w-full rounded-lg border border-gray-600 bg-[#1A1D1F] p-2.5 text-white focus:border-cosplay-blue-200 focus:ring-cosplay-blue-200"
                  >
                    <option value="">Select a reason...</option>
                    {CANCELLATION_REASONS.map((reason) => (
                      <option value={reason.code}>{reason.description}</option>
                    ))}
                  </select>
                </div>

                <div class="mt-4 flex justify-end gap-3">
                  <button
                    class="rounded-lg px-4 py-2 text-gray-300 hover:text-white"
                    onClick={props.onClose}
                  >
                    Cancel
                  </button>
                  <button
                    class="flex items-center gap-2 rounded-lg bg-cosplay-red px-4 py-2 text-white hover:bg-cosplay-red/90 disabled:opacity-50"
                    onClick={() => {
                      if (window.confirm('Are you sure you want to cancel your subscription?')) {
                        props.onConfirm(selectedReason())
                      }
                    }}
                    disabled={props.loading || !selectedReason()}
                  >
                    {props.loading ? (
                      <>
                        <div class="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                        Cancelling...
                      </>
                    ) : (
                      'Confirm Cancellation'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Show>
  )
}

export default CancellationModal
